import { useCallback } from 'react';
import { useMutation } from '@apollo/client';
import { FetchOptionsCallback } from 'global';
import { useNotifications } from 'modules/notification';

import { userAdditionalAccountsApi } from './index';

export function useUserAdditionalAccounts() {
  const { showNotification } = useNotifications();

  const [onSwitch, { loading }] = useMutation(userAdditionalAccountsApi.switchAccount);

  const handleSwitchAccount = useCallback(
    async (relationId: string, fetchOptions?: FetchOptionsCallback<typeof userAdditionalAccountsApi>) => {
      try {
        const { data } = await onSwitch({
          variables: {
            input: {
              relationId,
            },
          },
          ...(typeof fetchOptions == 'function' ? fetchOptions(userAdditionalAccountsApi) : {}),
        });

        showNotification('Account switched successfully!');
      } catch (error: any) {
        showNotification(error.message ?? 'Something went wrong', { type: 'error' });
      }
    },
    [onSwitch, showNotification]
  );

  return {
    handleSwitchAccount,
    isAccountSwitching: loading,
  };
}
